// test1732
(1732 && 0);
